import React from 'react';
import './SettingsSidebar.css';

const SettingsSidebar = ({ activeSection, onSectionChange }) => {
  const sections = [
    { id: 'restaurant', icon: '🏪', label: 'Restaurant Info' },
    { id: 'hours', icon: '⏰', label: 'Operating Hours' },
    { id: 'delivery', icon: '🚚', label: 'Delivery Settings' }
  ];

  return (
    <div className="settings-sidebar">
      <div className="sidebar-content">
        {sections.map(section => (
          <button
            key={section.id}
            className={`sidebar-tab ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => onSectionChange(section.id)}
            type="button"
          >
            <span className="tab-icon">{section.icon}</span>
            <span className="tab-label">{section.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SettingsSidebar;

